import React from 'react'

function DeleteIcon({ size = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill="none"
      {...props}
    >
      <path
        fill="#56565A"
        fillRule="evenodd"
        d="M21 5.997h-5v-1.67a2.42 2.42 0 0 0-2.5-2.33h-3A2.42 2.42 0 0 0 8 4.327v1.67H3a1 1 0 0 0 0 2h1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-11h1a1 1 0 1 0 0-2Zm-11-1.67c0-.16.21-.33.5-.33h3c.29 0 .5.17.5.33v1.67h-4v-1.67Zm8 14.67a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-11h12v11ZM10 17a1 1 0 0 0 1-1v-4a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1Zm4.707-.293A1 1 0 0 1 13 15.999v-4a1 1 0 0 1 2 0v4a1 1 0 0 1-.293.707Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
export default DeleteIcon
